import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import urlJoin from 'url-join';
import fetch from 'isomorphic-unfetch';
import { bearer, responseData } from '@@client/lib/request';
import { tokenRequest } from '@@client/lib/token-cache';
export function register(_x, _x2, _x3, _x4) {
  return _register.apply(this, arguments);
}

function _register() {
  _register = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenCache, apiUrl, portalId, query) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _objectSpread(_objectSpread({}, query), {}, {
              portalId: portalId
            });
            return _context.abrupt("return", tokenRequest(tokenCache, function (token) {
              return fetch(urlJoin(apiUrl, '/api/v1/account/register'), {
                method: 'post',
                body: JSON.stringify(query),
                headers: {
                  'Authorization': bearer(token),
                  'Content-Type': 'application/json'
                }
              }).then(responseData).then(function (_ref) {
                var response = _ref.response,
                    data = _ref.data;

                if (response.ok) {
                  return {
                    success: true,
                    payload: data
                  };
                } else if (response.status === 400) {
                  return {
                    success: false,
                    errors: data.errors.length ? data.errors : ['There were some problems with the values provided. Please see the error messages below.'],
                    paramErrors: data.paramErrors
                  };
                } else {
                  return {
                    success: false,
                    errors: data.errors,
                    paramErrors: []
                  };
                }
              });
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _register.apply(this, arguments);
}